import PageHeading from '../../../shared/PageHeading'
import classes from './DocumentReviewAssessment.module.scss'
import Button from '../../../shared/ComponentLibrary/RButton'
import useAssessment from '../../../../customHooks/useAssessment'
import { useForm, SubmitHandler } from 'react-hook-form'
import InputField from '../../../shared/ComponentLibrary/RInputField'
import BreadcrumbsPath from '../../../shared/BreadcrumbsPath'


const AssessmentFeedback = () => {
  const { register, handleSubmit, watch, formState: { errors } } = useForm()
  const { submitComment } = useAssessment()

  interface IDataToSubmit {
    comment: string
  }

  const submitCommentFeedback: SubmitHandler<IDataToSubmit> = (data) => {
    submitComment(data.comment)
  }

  return (
    <div className='h-100'>
      <div className={classes.header}>
        <PageHeading title='ReviewRight® Assessment Results' icon='testResults' />
        <BreadcrumbsPath />
      </div>

      <div className={classes.assessment_section}>
        <form onSubmit={handleSubmit(submitCommentFeedback)} >
          <div className={classes.feedback}>
            <div className={classes.congratulations}>
              Congratulations! You made it through the ReviewRight e-Discovery Assessment!
            </div>
            <div className={classes.feedback_text}>
              If you had any problems with the test, such distractions or disruptions, or have any general comments regarding the test or testing process, please submit them below.
              <br/>
              If you experience technical issues during your exam, take a screen shot and contact us immediately via email at staffing@haystackid.com with your evidence.
            </div>
            <div className={classes.input_field}>
              <InputField
                name="comment"
                textArea
                register={{ ...register('comment') }}
              />
            </div>
            <div>
              <Button type='submit' innerText='Submit Comment' size='large' />
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export default AssessmentFeedback
